import React, { FC, useState } from "react";
import { MatchStatus } from "service";
import { SimulatorInner } from "./Simulator";

export const DebugMode: FC = () => {
  const [status, setStatus] = useState<MatchStatus | undefined>();

  const [statusList, setStatusList] = useState<MatchStatus[]>([]);

  return (
    <>
      <textarea
        className="w-full h-full"
        onChange={(e) => {
          try {
            const st = JSON.parse(e.target.value);
            if (Array.isArray(st)) {
              setStatusList(st);
              setStatus(st[0]);
            } else {
              setStatus(st);
            }
          } catch {}
        }}
      />
      <div className="flex justify-center">
        {statusList.map((status, i) => (
          <button key={i} onClick={() => setStatus(status)}>
            {i}
          </button>
        ))}
      </div>
      {status && <SimulatorInner status={status} />}
    </>
  );
};
